// Legacy URL redirect map.
// Old URLs from the previous abs-solutions.com.au site (GoDaddy-built) → new
// React SPA URLs. The keys are the *decoded* pathname (without origin) so we
// can match whether the browser keeps Chinese chars unencoded or percent-
// encodes them — `decodeURIComponent` is applied before lookup.
//
// All keys are lower-cased to make matching case-insensitive.
const LEGACY_REDIRECTS = {
  // Chinese pages — moved under /zn/
  "/澳洲负扣税全面解析": "/zn/negative-gearing",
  "/澳洲家庭信托全攻略": "/zn/family-trust-guide",
  "/澳洲报税截止日期": "/zn/australian-tax-deadlines",
  "/澳洲如何申请abn": "/zn/how-to-apply-abn",
  "/墨尔本会计报税": "/zn/melbourne-accounting-tax",
  "/澳洲bas申报": "/zn/bas-lodgement",
  "/澳洲gst税註冊及申報": "/zn/gst-registration",
  "/澳洲华人会计师事务所": "/zn/chinese-accountants-australia",
  "/墨尔本公司及个人报税": "/zn/melbourne-company-personal-tax",
  "/公务出差费用如何报税": "/zn/business-travel-tax",
  "/墨尔本会计师事务所": "/zn/melbourne-accounting-firm",
  "/居家办公怎么报税": "/zn/home-office-tax",
  "/自管养老金smsf": "/zn/smsf",
  "/澳洲企业怎么报税": "/zn/business-tax",
  "/个人报税服务": "/zn/individual-tax-services",
  "/澳洲小生意报税": "/zn/small-business-tax",
  "/我们的收费价格": "/zn/services-and-price",
  "/专业公司报税服务": "/zn/company-tax-services",
  "/公司架构设立与商业计划服务": "/zn/company-setup",

  // Old blog/article URLs → most relevant new long-form article
  "/f/comprehensive-guide-to-financial-management-for-businesses": "/cash-flow-management-small-business",
  "/f/the-comprehensive-guide-to-australian-taxation": "/insights",
};

/**
 * Resolve a legacy pathname → new pathname (or null if no redirect).
 * Handles trailing slashes, URL encoding, and case-insensitive matching.
 */
export function resolveLegacyRedirect(rawPathname) {
  if (!rawPathname) return null;
  let path = rawPathname;
  // Strip trailing slash (except root)
  if (path.length > 1 && path.endsWith("/")) path = path.slice(0, -1);
  // Decode percent-encoded characters
  try {
    path = decodeURIComponent(path);
  } catch (_e) {
    // ignore malformed URI
  }
  path = path.toLowerCase();
  return LEGACY_REDIRECTS[path] || null;
}

export default LEGACY_REDIRECTS;
